import { createApp, pinia } from './vue';

import heroCarousel from './vue/apps/hero-carousel';

const heroCarouselMountingContainer = document.querySelectorAll('.js-hero-carousel-container');

if (heroCarouselMountingContainer) {
    const carouselHeros = [];

    heroCarouselMountingContainer.forEach((el) => {
        const app = createApp(heroCarousel).use(pinia).mount(el);
        carouselHeros.push(app);
    });
}
